import { FC, useMemo, useState } from 'react'

import { calculateFileLink } from 'core/classes/helpers/saveFiles'
import { IPartnerContact } from 'partner360/features/contacts'

import { InitialsPlaceholder } from '../contactImageUploader/InitialsPlaceholder'
import { PartnerContactRoles } from '../partnerContactRoles/PartnerContactRoles'

import styles from './PartnerContactCard.module.scss'

interface IPartnerContactCardProps {
  contact: IPartnerContact
}

export const PartnerContactCard: FC<IPartnerContactCardProps> = ({ contact }) => {
  const [showInitials, setShowInitials] = useState(false)

  const fullName = useMemo(() => {
    if (contact.FullName) {
      return contact.FullName.trim() || '-'
    }

    return [contact.FirstName, contact.LastName].filter(Boolean).join(' ').trim() || '-'
  }, [contact.FirstName, contact.FullName, contact.LastName])

  const image = useMemo(() => {
    if (!contact.Image) {
      return
    }

    return calculateFileLink({
      entryId: contact.EntryId,
      formId: 700,
      fieldName: 'Image',
      fileName: contact.Image,
      UID: contact.UID,
    })
  }, [contact.EntryId, contact.Image, contact.UID])

  return (
    <div className={styles.card}>
      <div className={styles.cardImage}>
        {image && !showInitials ? (
          <img src={image} onError={() => setShowInitials(true)} />
        ) : (
          <InitialsPlaceholder
            firstName={contact.FirstName}
            lastName={contact.LastName}
            fullName={contact.FullName}
            className={styles.cardImagePlaceholder}
          />
        )}
      </div>
      <div className={styles.cardDetails}>
        <div className={styles.cardName}>{fullName}</div>
        <PartnerContactRoles role={contact.Roles} />
      </div>
    </div>
  )
}

PartnerContactCard.displayName = 'PartnerContactCard'
